import { LangType, LangOption } from '@/types/common';

export const languages: LangType[] = [
  'en',
  'pl',
  'sl',
  'de',
  'uk',
  'bg',
  'cz',
  'fr',
  'gr',
  'it',
  'pr',
  'ru',
  'sk',
  'sp',
  'tr',
  'hu',
];

export const langOptions: LangOption = {
  en: { id: 'en', name: 'English' },
  pl: { id: 'pl', name: 'Polski' },
  sl: { id: 'sl', name: 'Slovenščina' },
  de: { id: 'de', name: 'Deutsch' },
  uk: { id: 'uk', name: 'Українська' },
  bg: { id: 'bg', name: 'Български' },
  cz: { id: 'cz', name: 'Čeština' },
  fr: { id: 'fr', name: 'Français' },
  gr: { id: 'gr', name: 'Ελληνικά' },
  it: { id: 'it', name: 'Italiano' },
  pr: { id: 'pr', name: 'Português' },
  ru: { id: 'ru', name: 'Русский' },
  sk: { id: 'sk', name: 'Slovenčina' },
  sp: { id: 'sp', name: 'Español' },
  tr: { id: 'tr', name: 'Türkçe' },
  hu: { id: 'hu', name: 'Magyar' },
};
export const langOptionsArray = Object.values(langOptions);
export const DEFAULT_LANGUAGE: LangType = 'en';
